import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  InputGroup,
  FormControl
} from 'react-bootstrap'
import {
  ContentHeader,
  ContentIcon,
  ContentTitle,
  ContentBody,
  ContentButton
} from 'components/Content'
import {
  ToggleModal,
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import Scrollbars from 'components/Scrollbars'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import CardTagsAction from 'components/CardActions/Tags'
import Tag from 'components/Tag'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import CreateLabel from './CreateLabel'
import classes from './Labels.module.scss'
import { withBoardPermission } from 'dataProviders/Board'

export class Labels extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    isArchived: PropTypes.bool.isRequired,
    labels: PropTypes.array.isRequired,
    labelsById: PropTypes.object.isRequired,
    boardLabels: PropTypes.array.isRequired,

    requestAddLabel: PropTypes.func.isRequired,
    requestRemoveLabel: PropTypes.func.isRequired
  }

  state = {
    showModal: false,
    isCreating: false,
    query: ''
  }

  showCreate = () => {
    this.setState({
      isCreating: true
    })
  }

  hideCreate = () => {
    this.setState({
      isCreating: false,
      query: ''
    })
  }

  handleTagClick = ({ id }) => {
    const {
      cardContext,
      labels,
      requestAddLabel,
      requestRemoveLabel
    } = this.props

    const selected = labels.indexOf(id) !== -1

    if (!selected) {
      requestAddLabel({
        cardId: cardContext.id,
        labelId: id
      })
    } else {
      requestRemoveLabel({
        cardId: cardContext.id,
        labelId: id
      })
    }
  }

  handleModalToggle = (show) => {
    if (show === false) {
      this.setState({ showModal: false })
    }
  }

  handleAddLabelClick = () => {
    this.setState({
      showModal: true,
      isCreating: false,
      query: ''
    })
  }

  handleSearchChange = (event) => {
    this.setState({
      query: event.target.value
    })
  }

  renderLabel = (labelId) => {
    const {
      cardContext,
      permission,
      isArchived,
      labelsById,
      requestRemoveLabel
    } = this.props

    const label = labelsById[labelId]

    if (!label) return null

    if (!isArchived && permission.member) {
      return (
        <ModalMenu>
          <Tag
            {...label}
            key={label.id}
            inline
            className='m-t-5 m-r-5'
          />
          <MenuItem
            icon={<KanBoIcon fixedWidth name='kanbo-16-remove' />}
            onClick={() => {
              requestRemoveLabel({
                cardId: cardContext.id,
                labelId: labelId
              })
            }}
          >
            <FormattedMessage id='REMOVE' />
          </MenuItem>
        </ModalMenu>
      )
    } else {
      return (
        <Tag
          {...label}
          key={label.id}
          inline
          className='m-t-5 m-r-5'
        />
      )
    }
  }

  render () {
    const {
      permission,
      isArchived,
      labels,
      boardLabels
    } = this.props
    const {
      showModal,
      isCreating,
      query
    } = this.state

    const filteredBoardLabels =
      (
        query
          ? boardLabels.filter(label => label.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
          : boardLabels
      )

    return (
      <Content>
        <ToggleModal
          backdrop
          attachClickHandler={false}
          show={showModal}
          onToggle={this.handleModalToggle}
          attachment='top left'
          targetAttachment='bottom left'
          constraints={[
            {
              to: 'window',
              pin: true
            }
          ]}
        >
          <ContentHeader>
            <ElementContentIcon>
              <KanBoIcon name='kanbo-24-labels' />
            </ElementContentIcon>
            <ContentTitle>
              <FormattedMessage id='LABELS' />
            </ContentTitle>
          </ContentHeader>
          <div className={classes.modal}>
            {isCreating ? (
              <CreateLabel
                name={query}
                onCancelClick={this.hideCreate}
              />
            ) : (
              <React.Fragment>
                <InputGroup
                  bsClass={permission.owner ? undefined : ''}
                  className={classes.searchInputWrapper}
                >
                  <FormattedMessage id='SEARCH_PLACEHOLDER'>
                    {formattedMessage =>
                      <FormControl
                        autoFocus
                        type='text'
                        placeholder={formattedMessage}
                        value={query}
                        onChange={this.handleSearchChange}
                      />
                    }
                  </FormattedMessage>
                  {permission.owner &&
                    <InputGroup.Button>
                      <Button
                        icon={<KanBoIcon name='kanbo-16-plus' />}
                        onClick={this.showCreate}
                      >
                        <FormattedMessage id='LABEL_CREATE' />
                      </Button>
                    </InputGroup.Button>
                  }
                </InputGroup>
                {filteredBoardLabels.length > 0 ? (
                  <Scrollbars>
                    <CardTagsAction
                      tags={filteredBoardLabels}
                      selectedTags={labels}
                      onTagClick={this.handleTagClick}
                    />
                  </Scrollbars>
                ) : (
                  <div className={classes.noResults}>
                    <FormattedMessage id='NOTHING_TO_SHOW' />
                  </div>
                )}            
              </React.Fragment>
            )}
          </div>
        </ToggleModal>
        {labels.length > 0 &&
          <ContentBody className={classes.labelsWrapper}>
            {labels.map(this.renderLabel)}
          </ContentBody>
        }
        {(!isArchived && permission.member) &&
          <ContentButton
            onClick={this.handleAddLabelClick}
          >
            <ContentIcon>
              <KanBoIcon name='kanbo-16-plus' />
            </ContentIcon>
            <ContentTitle>
              <FormattedMessage id='LABEL_ADD' />
            </ContentTitle>
          </ContentButton>
        }
      </Content>
    )
  }
}

export default withBoardPermission(Labels)
